import { Component, inject } from '@angular/core';
import { Language, LanguageService } from '@ibc/shared/services/language.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-language-selector',
  imports: [TranslateModule],
  templateUrl: './language-selector.component.html',
  styleUrl: './language-selector.component.scss',
})
export class LanguageSelectorComponent {
  private languageService = inject(LanguageService);

  onLanguageSelect(language: Language): void {
    this.languageService.setLanguage(language);
    this.reloadApplication();
  }

  private reloadApplication(): void {
    window.location.reload();
  }
}
